import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
const app = initializeApp({
  apiKey: "AIzaSyDpU5dsxmd-QFVsGddZJmICFZxwLBoW-dw",
  authDomain: "apprely-b34c5.firebaseapp.com",
  projectId: "apprely-b34c5",
  storageBucket: "apprely-b34c5.appspot.com",
  messagingSenderId: "325079228971",
  appId: "1:325079228971:web:4621874cf981e27164c06e"
});
// const app = initializeApp({
//   projectId: process.env.PROJECTID,
//   apiKey: process.env.APIKEY,
//   authDomain: process.env.AUTHDOMAIN,
//   // storageBucket: process.env.STORAGEBUCKET,
//   storageBucket: "gs://apprely-b34c5.appspot.com",
//   messagingSenderId: process.env.MESSAGINGSENDERID,
//   appId: process.env.APPID,
// });
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const imagDb = getStorage(app);
export const jobDb = getFirestore(app);
